import {
  UserActivityStatus,
  UserSetAvailabilityStatus,
} from '@api/generated/graphql';
import { useSnapshot } from 'valtio';
import { serviceState } from '../workspace/lib/state';
import { ServiceUserUtils } from '../workspace/lib/serviceUserUtils';

export interface UserStatus {
  userId: string | null;
  status: UserSetAvailabilityStatus;
  canChange: boolean;
  loading: boolean;
  error?: string | null;
  activity: UserActivityStatus;
}

/**
 * Hook that gets the current user's status information from ServiceModule state.
 */
export function useUserStatus({
  userId,
}: {
  userId?: string | null;
}): UserStatus {
  const state = useSnapshot(serviceState);
  const user = userId ? state.userById[userId] : null;

  if (!user) {
    return {
      userId: null,
      status: UserSetAvailabilityStatus.Offline,
      canChange: false,
      loading: state.loading ?? false,
      error: state.error as string | undefined,
      activity: UserActivityStatus.None,
    };
  }

  const userStatusUpdate = userId ? state.updateUserStatusById[userId] : null;

  return {
    userId: state.id,
    status: ServiceUserUtils.getAvailabilityStatus(user),
    canChange: ServiceUserUtils.getCanChange(user),
    activity: ServiceUserUtils.getActivityStatus(user),
    loading: userStatusUpdate?.loading ?? state.loading ?? false,
    error: userStatusUpdate?.error ?? (state.error as string | undefined),
  };
}
